import { Component, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';

@Component({
  selector: 'aira-string',
  templateUrl: './aira-string.component.html',
  styleUrl: './aira-string.component.css',
  standalone: false,
})
export class AiraStringComponent {
  @Input() label = '';
  @Input() value = '';
  @Input() previewOnly: boolean = false;

  get stringValue(): string {
    const displayedValue = this.previewOnly
      ? magicPreviewDummyData.stringSimple
      : this.value;
    const valueAsString = displayedValue?.toString() ?? '';
    return valueAsString === 'true'
      ? 'Yes'
      : valueAsString === 'false'
        ? 'No'
        : valueAsString;
  }
}
